import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col } from 'react-bootstrap';
import { Route, Routes as Switch } from "react-router-dom";

import Header from '../../layout/header';
import BreadcrumbList from "../../layout/breadcrumbs";
import pages from "../../constants/menu";
import breadcrumbs, { find } from "../../layout/breadcrumbs/calculate";
import Layout from "../../layout";

import Profile from "../profile";
import Files from "../files";
import Surveys from "../surveys";
import NotificationsPage from "../notifications";
import Display from "./display";


class Dashboard extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            page: find(window.location.pathname, pages),
        }
    }

    componentDidUpdate(oldProps) {

    }

    get title() {
        return this.props.page?.title?.trim().length
            ? this.props.page.title
            : this.state.page?.title;
    }


    render() {
        return (
            <>
                <Layout>
                    <Header
                        title={`${localStorage.title ?? ""} | ${this.title ?? ""}`}
                        description={`${this.props.profile?.dashboardTitleBase || ""} | ${this.state.page?.description || ""}`}
                    />
        
                    {/* Title and Top Buttons Start */}
                    <div className="page-title-container">
                        <Row>
                            {/* Title Start */}
                            <Col md="4">
                                <h1 className="mb-0 pb-0 display-4">{this.title ?? ""}</h1>
                                <BreadcrumbList items={breadcrumbs(window.location.pathname, pages)} title={this.props.page?.breadcrumb} />
                            </Col>
                            <Switch>
                                <Route exact={true} path="/profile" element={<Profile />} />
                                <Route exact={true} path="/files" element={<Files />} />
                                <Route exact={true} path="/surveys" element={<Surveys />} />
                                <Route exact={true} path="/notifications" element={<NotificationsPage />} />
                                
                                <Route exact={true} path="/" element={<Display />} />
                            </Switch>
                        </Row>
                        <Row>

                        </Row>
                    </div>
                    {/* Title and Top Buttons End */}
                    
                </Layout>
            </>
        );
    }
}

Dashboard.propTypes = {
    auth: PropTypes.object,
    profile: PropTypes.object,
    page: PropTypes.object
};

Dashboard.defaultProps = {
    auth: {},
    profile: {},
    page: {}
};

const mapStateToProps = (state) => {
    return {
        auth: state.auth || {},
        profile: state.licensee?.profile || {},
        page: state.page || {},
    };
};

export default connect(mapStateToProps)(Dashboard);
